import { useHandler } from "@redotech/react-util/hook";
import EyeIcon from "@redotech/redo-icons/eye.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";
import { TRUEUP_JOB_SUMMARY } from "./support-v2-maintenance-options";
import { TrueUpSupportV2Modal } from "./true-up-support-v2-modal";

export const TrueUpSupportV2Card = memo(function TrueUpSupportV2Card({
  teamId,
}: {
  teamId: string;
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = useHandler(() => setModalOpen(true));
  const closeModal = useHandler(() => setModalOpen(false));

  return (
    <>
      <Card radius="sm" title="True-up support-v2 tickets">
        <Flex dir="column" gap="lg" w="full">
          <Text fontSize="sm" textColor="secondary">
            {TRUEUP_JOB_SUMMARY}
          </Text>
          <Flex align="center" gap="sm" wrap="wrap">
            <RedoButton
              hierarchy="primary"
              IconLeading={EyeIcon}
              onClick={openModal}
              text="Open true-up"
            />
          </Flex>
        </Flex>
      </Card>

      {modalOpen && (
        <TrueUpSupportV2Modal onClose={closeModal} teamId={teamId} />
      )}
    </>
  );
});
